<div class="container">
  <div class="container-content content">
    <div class="search">
      <div class="search-input input align-center d-flex">
        <input
          class="input-box box"
          type="text"
          placeholder="Buscar"
          [formControl]="queryField"
          (change)="searchField(queryField.value)"
          (keyup.enter)="searchField(queryField.value)"
        />
        <app-svg-icon
          class="input-icon"
          width="15px"
          height="17px"
          color="white"
          src="assets/icons/search-icon.svg"
          alt="search"
        >
        </app-svg-icon>
      </div>
    </div>

    <div class="content-list list">
      <ng-container class="list-header">
        <app-header-list [headerItems]="headerParametros"></app-header-list>
      </ng-container>

      <div class="list-cards cards">
        <ng-container *ngFor="let parameter of parametersList">
          <app-card-configuracoes
            [cardType]="DialogEmailTypeEnum.Parameters"
            [parameter]="parameter"
            (updateParameterEvent)="handlerUpdateParameter($event)"
          ></app-card-configuracoes>
        </ng-container>
      </div>
    </div>
  </div>
</div>
